import React, { useState } from 'react';
import { Button } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import { useNotify, useRefresh } from 'react-admin';
import r from '../../Utils/fetch';

const w: any = window;

interface SyncResult {
	plansCreated: number;
	plansUpdated: number;
	featuresCreated: number;
	featuresUpdated: number;
}

const SyncFromStripeButton: React.FC = () => {
	const [loading, setLoading] = useState(false);
	const notify = useNotify();
	const refresh = useRefresh();

	const handleSync = async () => {
		setLoading(true);
		try {
			const res = await r<SyncResult>({
				url: `${w.API_BILLING_URL}/v1/admin/stripe/sync`,
				method: 'POST',
			});
			notify(
				`Sync done — Plans: +${res.plansCreated} created, ${res.plansUpdated} updated · Features: +${res.featuresCreated} created, ${res.featuresUpdated} updated`,
				{ type: 'success' }
			);
			refresh();
		} catch (error: any) {
			notify(`Sync failed: ${error.message || 'Unknown error'}`, { type: 'error' });
		} finally {
			setLoading(false);
		}
	};

	return (
		<Button
			variant="text"
			color="primary"
			startIcon={<SyncIcon />}
			onClick={handleSync}
			disabled={loading}
		>
			{loading ? 'Syncing...' : 'Sync from Stripe'}
		</Button>
	);
};

export default SyncFromStripeButton;
